<template>
  <default-layout>
    <section slot="content">
      <v-container
        fluid
      >
        <v-row justify="center">
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">

              <v-col cols="12" lg="8" md="12" sm="12" xs="12">
                <v-stepper
                  v-model="e6"
                  vertical
                >
                  <v-stepper-step
                    :editable="e6 > 1"
                    :complete="e6 > 1"
                    step="1"
                  >
                    Identificación
                    <small>Completar datos personales</small>
                  </v-stepper-step>

                  <v-stepper-content step="1">
                    <v-card
                      class="mb-12"
                    >
                      <template>
                        <v-form
                          ref="form"
                          v-model="form"
                          class="pa-4 pt-6"
                        >
                          <v-text-field
                            v-model="obj.email"
                            filled
                            :rules="[rules.email]"
                            color="primary"
                            label="Correo"
                            type="email"
                            class="ma-0 pa-0"
                            outlined
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-model="obj.name"
                            filled
                            :rules="[rules.required]"
                            color="primary"
                            label="Nombre"
                            type="text"
                            class="ma-0 pa-0"
                            outlined
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-model="obj.lastName"
                            filled
                            :rules="[rules.required]"
                            color="primary"
                            label="Apellidos"
                            type="text"
                            class="ma-0 pa-0"
                            outlined
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-model="obj.idDoc"
                            filled
                            :rules="[rules.required]"
                            color="primary"
                            label="Documento de identidad"
                            class="ma-0 pa-0"
                            outlined
                            dense
                          ></v-text-field>
                          <v-text-field
                            v-model="obj.phone"
                            filled
                            :rules="[rules.required]"
                            color="primary"
                            label="Número de teléfono"
                            class="ma-0 pa-0"
                            outlined
                            dense
                          ></v-text-field>
                          <v-checkbox
                            v-model="obj.acceptConditions"
                            :rules="[rules.required]"
                            color="primary"
                            class="body-1"
                          >
                            <template v-slot:label class="body-2">
                              <div class="body-2">Acepto los&nbsp;
                              <a
                                href="#"
                                @click="redirect('Conditions')"
                                target="_blank"
                              >Términos y Condiciones</a>
                              &nbsp;y las&nbsp;
                              <a
                                href="#"
                                @click="redirect('PrivacyPolicy')"
                                target="_blank"
                              >Políticas de Privacidad</a>
                              </div>
                            </template>
                          </v-checkbox>
                        </v-form>
                      </template>
                    </v-card>
                    <v-btn :disabled="!form || (form && disabledSubmit)" color="primary" @click="saveClient()" depressed>
                      Continuar
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step
                    :editable="e6 > 2"
                    :complete="e6 > 2"
                    step="2"
                  >
                    Envío
                  </v-stepper-step>

                  <v-stepper-content step="2">
                    <v-card
                      class="mb-12"
                    >

                      <template>
                        <div class="text-center">
                          <v-row justify="center">
                            <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                              <v-btn
                                block
                                class="ma-2"
                                :style="[(obj.shipping_type_id == 1) ? {'border-bottom': '#00a1df 2px solid', 'background': '#f2f4f5', 'color': '#00a1df'} : {'border-bottom': '0px', 'background': '#f2f4f5'}]"
                                @click="obj.shipping_type_id = 1"
                              >
                                <v-icon left dark>local_shipping</v-icon>
                                Delivery
                              </v-btn>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                              <v-btn
                                block
                                class="ma-2"
                                :style="[(obj.shipping_type_id == 2) ? {'border-bottom': '#00a1df 2px solid', 'background': '#f2f4f5', 'color': '#00a1df'} : {'border-bottom': '0px', 'background': '#f2f4f5'}]"
                                @click="obj.shipping_type_id = 2"
                              >
                                <v-icon left dark>store</v-icon>
                                Retiro en tienda
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </template>

                      <template v-if="obj.shipping_type_id == 1 || obj.shipping_type_id == 2">
                        <template>
                          <v-form
                            ref="formDelivery"
                            v-model="formDelivery"
                            class="pa-4 pt-6"
                          >
                            <v-select
                              label="Departamento"
                              filled
                              :rules="[rules.required]"
                              class="ma-0 pa-0"
                              outlined
                              dense
                              v-model="obj.departmentId"
                              :items="obj.shipping_type_id == 1 ? select.departments : filteredDepartments"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                            <v-select
                              label="Provincia"
                              filled
                              :rules="[rules.required]"
                              class="ma-0 pa-0"
                              outlined
                              dense
                              v-model="obj.provinceId"
                              :items="obj.shipping_type_id == 1 ? select.provinces : filteredProvinces"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                            <v-select
                              label="Distrito"
                              filled
                              :rules="[rules.required]"
                              class="ma-0 pa-0"
                              outlined
                              dense
                              v-model="obj.districtId"
                              :items="obj.shipping_type_id == 1 ? select.districts : filteredDistricts"
                              item-text="name"
                              item-value="id"
                            ></v-select>

                            <template v-if="obj.shipping_type_id == 1">
                              <v-text-field
                                v-model="obj.address"
                                filled
                                :rules="[rules.required]"
                                color="primary"
                                label="Ingrese su dirección"
                                type="text"
                                class="ma-0 pa-0"
                                outlined
                                dense
                              ></v-text-field>
                              <v-text-field
                                v-model="obj.reference"
                                filled
                                color="primary"
                                label="Referencia"
                                type="text"
                                class="ma-0 pa-0"
                                outlined
                                dense
                              ></v-text-field>
                            </template>
                            <template v-else>
                              <v-textarea
                                v-model="obj.address"
                                outlined
                                disabled
                                label="Alamacén"
                                rows="1"
                                auto-grow
                              ></v-textarea>
                            </template>

                            <v-date-picker
                              v-model="cartTmp.delivery_day"
                              full-width
                              class="mt-4"
                              locale="es"
                              :max="maxDate"
                              :show-current="false"
                              color="primary"
                              no-title
                            ></v-date-picker>

                            <template>
                              <v-container fluid>
                                <v-radio-group v-model="cartTmp.person_reception" row>
                                  <template v-slot:label>
                                    <div>¿Quién recibirá el pedido?</div>
                                  </template>
                                  <v-radio value="1">
                                    <template v-slot:label>
                                      <div>Yo</div>
                                    </template>
                                  </v-radio>
                                  <v-radio value="2">
                                    <template v-slot:label>
                                      <div>Otra persona</div>
                                    </template>
                                  </v-radio>
                                </v-radio-group>
                              </v-container>
                            </template>
                          </v-form>
                        </template>

                        <template v-if="cartTmp.person_reception == 2">
                          <v-form
                            ref="formReception"
                            v-model="formReception"
                            class="pa-4 pt-0"
                          >
                            <v-text-field
                              v-model="cartTmp.name_reception"
                              filled
                              :rules="[rules.required]"
                              color="primary"
                              label="Nombre"
                              type="text"
                              class="ma-0 pa-0"
                              outlined
                              dense
                            ></v-text-field>
                            <v-text-field
                              v-model="cartTmp.last_name_reception"
                              filled
                              :rules="[rules.required]"
                              color="primary"
                              label="Apellidos"
                              type="text"
                              class="ma-0 pa-0"
                              outlined
                              dense
                            ></v-text-field>
                            <!-- <v-text-field
                              v-model="cartTmp.identification_doc_reception"
                              filled
                              :rules="[rules.required]"
                              color="primary"
                              label="Documento de identidad"
                              class="ma-0 pa-0"
                              outlined
                              dense
                            ></v-text-field> -->
                          </v-form>
                        </template>
                      </template>
                    </v-card>
                    <v-btn color="primary" :disabled="disabledBtnDelivery || (!disabledBtnDelivery && disabledSubmit)" @click="saveAddress()">
                      Método de pago
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step
                    :complete="e6 > 3"
                    step="3"
                  >
                    Método de pago
                  </v-stepper-step>

                  <v-stepper-content step="3" class="ml-n2">
                    <v-container>
                      <v-row dense>
                        <template v-for="(item, i) in items">
                          <v-col cols="12">
                            <v-card outlined>
                              <v-list-item three-line>
                                <v-list-item-content>
                                  <v-radio-group v-model="obj.payment_type_id">
                                    <v-radio :value="item.value">
                                      <template v-slot:label>
                                        <div>{{ item.title }}</div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>
                                  <v-list-item-content class="mt-n4">{{ item.detail }}</v-list-item-content>
                                </v-list-item-content>
                                <v-list-item-avatar tile size="80">
                                  <v-img :src="item.image"></v-img>
                                </v-list-item-avatar>
                              </v-list-item>
                            </v-card>
                          </v-col>
                        </template>
                      </v-row>
                    </v-container>
                    <v-btn :disabled="disabledSubmit" color="primary" @click="saveOrder()">
                      Realizar Pedido
                    </v-btn>
                  </v-stepper-content>
                </v-stepper>
              </v-col>

              <!-- ********************************** -->
              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <v-card>
                  <v-card-title class="justify-center">Carrito de compras</v-card-title>
                  <v-virtual-scroll :items="cartDetailTmp" :item-height="112" :height="heightScroll" style="overflow-y: auto !important">
                    <template v-slot="{ item, index }">
                      <v-card-title>
                        <v-row no-gutters>
                          <v-col cols="6" md="4" sm="4" xs="6">
                            <v-card class="overline text-left" style="border: 0" outlined elevation="0">
                              <div>
                                <v-badge
                                  color="primary"
                                  overlap
                                  :content="item.quantity"
                                >
                                  <v-avatar size="80" tile>
                                    <v-img :src="item.product_color.product_color_image[0].image"></v-img>
                                  </v-avatar>
                                </v-badge>
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="6" md="5" sm="5" xs="6">
                            <v-card class="body-2 text-left ml-n6" style="border: 0px" outlined elevation="0">
                              {{ item.product.name }}
                            </v-card>
                            <v-card class="body-2 text-left ml-n6" style="border: 0px" outlined elevation="0">
                              S/ {{ item.unit_price }}
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="3" sm="3" xs="12">
                            <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                              S/ {{ item.amount }}
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </template>
                  </v-virtual-scroll>
                  <v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" sm="12">
                        <v-card-title primary-title>
                          <v-divider></v-divider>
                        </v-card-title>
                      </v-col>
                      <v-col cols="6" md="6" sm="5" xs="6">
                        <v-card class="pl-8 body-2 text-left" style="border: 0px" outlined elevation="0">
                          Subtotal
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6" sm="3" xs="12">
                        <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                          S/ {{ cartTmp.subtotal }}
                        </v-card>
                      </v-col>
                      <v-col cols="6" md="6" sm="5" xs="6">
                        <v-card class="pl-8 body-2 text-left" style="border: 0px" outlined elevation="0">
                          Envío
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6" sm="3" xs="12">
                        <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                          S/ {{ cartTmp.shipping_price }}
                        </v-card>
                      </v-col>
                      <template v-if="cartTmp.coupon > 0 && cartTmp.coupon_code">
                        <v-col cols="6" md="6" sm="5" xs="6">
                          <v-card class="pl-8 body-2 text-left" style="border: 0px" outlined elevation="0">
                            Cupón
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="6" sm="3" xs="12">
                          <v-card class="body-2 text-right" style="border: 0px" outlined elevation="0">
                            - S/ {{ cartTmp.coupon }}
                          </v-card>
                        </v-col>
                      </template>
                      <v-col cols="12" sm="12">
                        <v-card-title primary-title>
                          <v-divider></v-divider>
                        </v-card-title>
                      </v-col>
                      <v-col cols="6" md="6" sm="5" xs="6">
                        <v-card class="pl-8 body-1 text-left" style="border: 0px" outlined elevation="0">
                          <strong>Total</strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6" sm="3" xs="12">
                        <v-card class="body-1 text-right" style="border: 0px" outlined elevation="0">
                          <strong>S/ {{ cartTmp.total }}</strong>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-title>
                </v-card>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
        <template>
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              top
            >
              {{ text }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  X
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import constants from '@/constants/index'

  export default {
    name: 'Payment',
    components: {
      DefaultLayout
    },
    data () {
      return {
        // radios: null,
        items: [
          {
            value: '1',
            image: require('@/assets/img/payments/logo_yape.png'),
            title: 'Pagar con YAPE',
            detail: 'Número de YAPE 987839662',
          }, {
            value: '2',
            image: require('@/assets/img/payments/logo_bancos.png'),
            title: 'Transferencia Bancaria',
            detail: `Realiza tu pago directamente en nuestra cuenta bancaria. Por favor, antes de realizar el pago, validar la disponibilidad por nuestros canales de atención. Tu pedido no se procesará hasta que se haya recibido el importe en nuestra cuenta.`,
          }
        ],
        e6: 1,
        dialog: false,
        cartTmp: {},
        cartDetailTmp: [],
        provinces: [],
        districts: [],
        deliveryDistricts: [],
        select: {
          departments: [],
          provinces: [],
          districts: [],
        },
        obj: {
          clientId: null,
          email: null,
          name: null,
          lastName: null,
          idDoc: null,
          phone: null,
          acceptConditions: null,
          addressId: null,
          departmentId: null,
          provinceId: null,
          districtId: null,
          address: null,
          reference: null,
          payment_type_id: null,
          shipping_type_id: null
        },
        form: false,
        formDelivery: false,
        formReception: false,
        rules: {
          email: v => /.+@.+\..+/.test(v) || 'Por favor ingresar un correo válido',
          length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
          required: v => !!v || 'Por favor completar este campo',
        },
        minDate: moment().add(0, 'days').format("yyyy-MM-DD"),
        maxDate: moment().add(7, 'days').format("yyyy-MM-DD"),
        snackbar: false,
        text: '',
        color: 'green',
        disabledSubmit: false,
      }
    },
    computed: {
      disabledBtnDelivery () {
        if (!this.cartTmp.delivery_day) {
          return true;
        }

        return this.cartTmp.person_reception == 1 ? !this.formDelivery : (!this.formDelivery || !this.formReception);
      },

      heightScroll () {
        if (this.cartDetailTmp.length > 5) {
          return 549;
        } else {
          return 112 * this.cartDetailTmp.length;
        }
      },

      filteredDepartments() {
        return this.select.departments.filter(item => item.store == 1)
      },

      filteredProvinces() {
        return this.select.provinces.filter(item => item.store == 1)
      },
      filteredDistricts() {
        return this.select.districts.filter(item => item.store == 1)
      }
    },
    methods: {
      allowedDates(val) {
        if (this.obj.shipping_type_id == 1) {
          const calendarDay = moment(val).get('date');
          const currentDay = moment().get('date');

          if (calendarDay < currentDay) {
            return false;
          } else if (calendarDay === currentDay && moment(val).day() !== 0) {
            return moment().hour() < 9;
          } else {
            return moment(val).day() !== 0
          }
        } else {
          return true;
        }
      },

      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      redirect (name) {
        let routeData = this.$router.resolve({name: name });
        window.open(routeData.href, '_blank');
      },

      getDeliveryDistricts () {
        axios.get(process.env.DINO.PATH.GET_DELIVERIES)
        .then(response => {
          this.select.departments = response.data.departments;
          this.provinces = response.data.provinces;
          this.districts = response.data.districts;
          this.deliveryDistricts = response.data.deliveryDistricts;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getCart () {
        axios.get(process.env.DINO.PATH.GET_CART_DETAIL)
        .then(response => {

          if (!response.data.cartTmp || !response.data.cartDetailTmp) {
            this.$router.push({ name: 'HomePage' }).catch(err => {});
          }

          this.cartTmp = response.data.cartTmp;
          this.cartTmp.delivery_day = response.data.cartTmp.delivery_day ? new Date(response.data.cartTmp.delivery_day).toISOString().substr(0, 10) : null;
          this.cartTmp.person_reception = this.cartTmp.person_reception + '';
          this.cartDetailTmp = response.data.cartDetailTmp;
          this.obj.shipping_type_id = response.data.cartTmp.shipping_type_id;
        })
        .catch(err => {
        })
        .then(() => {
          if (this.cartTmp.client_id) {
            this.getClient();
          }
        });
      },

      getClient () {
        axios.get(process.env.DINO.PATH.GET_CLIENT_DETAIL.replace(':clientId', this.cartTmp.client_id))
        .then(response => {
          if (response.data.client) {
            this.obj.clientId = response.data.client.id;
            this.obj.email = response.data.client.email;
            this.obj.name = response.data.client.name;
            this.obj.lastName = response.data.client.last_name;
            this.obj.idDoc = response.data.client.identification_doc;
            this.obj.phone = response.data.client.phone;
            this.obj.acceptConditions = response.data.client.accept_conditions;
            this.obj.addressId = response.data.address.id;
            this.obj.departmentId = response.data.address.department_id;
            this.obj.provinceId = response.data.address.province_id;
            this.obj.districtId = response.data.address.district_id;
            this.obj.primary = response.data.address.primary;
            this.obj.address = response.data.address.address;
            this.obj.reference = response.data.address.reference;
          }
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      errorClient () {
        if (this.obj.email &&
            this.obj.name &&
            this.obj.lastName &&
            this.obj.idDoc &&
            this.obj.phone &&
            this.obj.acceptConditions &&
            /.+@.+\..+/.test(this.obj.email)) {
          return false;
        }

        return true;
      },

      saveClient () {
        this.disabledSubmit = true;
        if (this.errorClient()) {
          this.snackbar = true;
          this.text = '¡Ingresar datos del cliente por favor!';
          this.color = 'red';
          this.disabledSubmit = false;
          return;
        }

        const request = {
          cart_tmp_id: this.cartTmp.id,
          client_id: this.obj.clientId,
          email: this.obj.email,
          name: this.obj.name,
          last_name: this.obj.lastName,
          identification_doc: this.obj.idDoc,
          phone: this.obj.phone,
          accept_conditions: this.obj.acceptConditions,
        };

        axios.post(process.env.DINO.PATH.ADD_CLIENT, request)
        .then(response => {
          this.cartTmp.client_id = response.data.client_id;
          this.obj.clientId = response.data.client_id;
          this.e6 = 2;
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .catch(err => {
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .then(() => {
        });
      },

      errorAddress () {
        return false;
      },

      saveAddress () {
        this.disabledSubmit = true;
        if (this.errorAddress()) {
          this.snackbar = true;
          this.text = '¡Ingresar datos de envío por favor!';
          this.color = 'red';
          this.disabledSubmit = false;
          return;
        }

        const request = {
          cart_tmp_id: this.cartTmp.id,
          shipping_type_id: this.obj.shipping_type_id,
          shipping_price: this.cartTmp.shipping_price,
          delivery_day: this.cartTmp.delivery_day,
          person_reception: this.cartTmp.person_reception,
          name_reception: this.cartTmp.name_reception,
          last_name_reception: this.cartTmp.last_name_reception,
          id_doc_reception: this.cartTmp.identification_doc_reception,
          client_id: this.obj.clientId,
          address_id: this.obj.addressId,
          department_id: this.obj.departmentId,
          province_id: this.obj.provinceId,
          district_id: this.obj.districtId,
          address: this.obj.address,
          reference: this.obj.reference
        };

        axios.post(process.env.DINO.PATH.ADD_ADDRESS, request)
        .then(response => {
          this.getClient();
          this.e6 = 3;
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .catch(err => {
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        })
        .then(() => {
        });
      },

      saveOrder () {
        this.disabledSubmit = true;
        if (this.errorClient() || this.errorAddress() || !this.obj.payment_type_id) {
          this.snackbar = true;
          this.text = '¡Ingresar datos de cliente, envío o seleccionar método de pago por favor!';
          this.color = 'red';
          this.disabledSubmit = false;
          return;
        }

        const request = {
          cart_tmp_id: this.cartTmp.id,
          payment_type_id: this.obj.payment_type_id,
          shipping_type_id: this.obj.shipping_type_id,
          shipping_price: this.cartTmp.shipping_price,
          delivery_day: this.cartTmp.delivery_day,
          person_reception: this.cartTmp.person_reception,
          name_reception: this.cartTmp.name_reception,
          last_name_reception: this.cartTmp.last_name_reception,
          id_doc_reception: this.cartTmp.identification_doc_reception,
          client_id: this.obj.clientId,
          address_id: this.obj.addressId,
          department_id: this.obj.departmentId,
          province_id: this.obj.provinceId,
          district_id: this.obj.districtId,
          address: this.obj.address,
          reference: this.obj.reference
        };

        axios.post(process.env.DINO.PATH.SAVE_ORDER, request)
        .then(response => {
          if (response.data.success) {
            this.e6 = 4;
            this.$cookies.remove("key");
            setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
            this.$router.push({ name: 'PurchaseMade', params: { orderNumber: response.data.orderNumber } }).catch(err => {});
          } else {
            const color = response.data.success ? 'green' : 'red';
            this.showMessage(response.data.message, color);
            setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
          }
        })
        .catch(err => {
          this.snackbar = true;
          this.text = '¡Hubo un error al eliminar, por favor actualizar la página!';
          this.color = 'red';
          setTimeout(() => this.disabledSubmit = false, constants.NUMBER_2000);
        });
      },

      getImage (image) {
        try {
          return require('@/assets/img' + image);
        } catch (e) {
          return require('@/assets/img/products/default-image-notfound.jpg');
        }
      }
    },
    mounted: function () {
      this.getDeliveryDistricts();
      this.getCart();
    },
    watch: {
      'obj.departmentId': function (val) {
        if (val) {
          const self = this;
          this.provinces.forEach(function(obj) {
            if (obj.department_id == val) {
              self.select.provinces.push(obj);
            }
          });
        }
      },
      'obj.provinceId': function (val) {
        if (val) {
          const self = this;
          this.districts.forEach(function(obj) {
            if (obj.province_id == val) {
              self.select.districts.push(obj);
            }
          });
        }
      },
      'obj.districtId': function (val) {
        if (val) {
          if (this.obj.shipping_type_id == 1) {
            const self = this;
            this.deliveryDistricts.forEach(function(obj) {
              if (obj.district_id == val) {
                if (obj.size == 2) {
                  self.cartTmp.shipping_price = obj.price;
                  const coupon = self.cartTmp.coupon > 0 ? self.cartTmp.coupon : 0;
                  const total = (parseFloat(self.cartTmp.subtotal) + parseFloat(obj.price)) - parseFloat(coupon);
                  self.cartTmp.total = parseFloat(total).toFixed(2);
                }
              }
            });
          } else if (this.obj.shipping_type_id == 2) {
            this.obj.address = 'Almacén Villa el Salvador\nAv. Mariano Pastor Sevilla & Av. Talara, Villa EL Salvador 15837'
          }
        }
      },
      'obj.shipping_type_id': function (val) {
        if (val && this.$refs.formDelivery) {
          const coupon = this.cartTmp.coupon > 0 ? this.cartTmp.coupon : 0;
          const total = parseFloat(this.cartTmp.subtotal) - parseFloat(coupon);
          this.cartTmp.shipping_price = parseFloat(0).toFixed(2);
          this.cartTmp.total = total.toFixed(2);
          this.select.provinces = [];
          this.select.districts = [];
          this.obj.departmentId = null;
          this.obj.provinceId = null;
          this.obj.districtId = null;
          this.obj.address = null;
          this.obj.reference = null;
          this.cartTmp.delivery_day = null;
          this.cartTmp.name_reception = null;
          this.cartTmp.last_name_reception = null;
          this.cartTmp.person_reception = "1";
          this.$refs.formDelivery.resetValidation();
        }
      }
    }
  }
</script>
<style scoped>

.v-text-field >>> input {
  font-size: 0.9em;
}

.v-text-field >>> label {
  font-size: 0.9em;
}

.name-product {
  word-break: normal;
}

</style>



// WEBPACK FOOTER //
// src/views/Payment.vue